import React, { useState, useEffect } from "react";

interface ClearPaymentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmed: () => Promise<void>;
}

type Status = "confirming" | "clearing" | "cleared" | "error";

const STEPS = [
  "Have you Downloaded the Payments Table?",
  "Are you sure you want to clear the Payments Table?",
  "Last Chance! Are you sure that you want to clear the Payments Table?",
];

const ClearPaymentsModal: React.FC<ClearPaymentsModalProps> = ({
  isOpen,
  onClose,
  onConfirmed,
}) => {
  const [step, setStep] = useState<number>(0);
  const [status, setStatus] = useState<Status>("confirming");

  useEffect(() => {
    if (isOpen) {
      setStep(0);
      setStatus("confirming");
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleYes = async () => {
    if (step < STEPS.length - 1) {
      setStep(step + 1);
      return;
    }
    setStatus("clearing");
    try {
      await onConfirmed();
      setStatus("cleared");
    } catch {
      setStatus("error");
    }
  };

  const handleNo = () => {
    onClose();
  };

  const overlayStyle: React.CSSProperties = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  };

  const dialogStyle: React.CSSProperties = {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "4px",
    maxWidth: "500px",
    width: "90%",
    textAlign: "center",
  };

  const handleOverlayClick = () => {
    if (status === "clearing") {
      return;
    }
    onClose();
  };

  let body: React.ReactNode;
  if (status === "confirming") {
    body = (
      <>
        <p className="u-marg-bottom">{STEPS[step]}</p>
        <div>
          <button
            className="c-button +pos u-pad-left u-marg"
            onClick={handleYes}
          >
            YES
          </button>
          <button
            className="c-button +neg u-pad-left u-marg"
            onClick={handleNo}
          >
            NO
          </button>
        </div>
      </>
    );
  } else if (status === "clearing") {
    body = (
      <>
        <p className="u-marg-bottom">Clearing payments...</p>
        <div
          className="c-loader +thick"
          style={{ display: "inline-block" }}
        ></div>
      </>
    );
  } else if (status === "cleared") {
    body = (
      <>
        <p className="u-marg-bottom u-color-pos">
          Payments cleared successfully
        </p>
        <button
          className="c-button +pos u-pad-left u-marg"
          onClick={onClose}
        >
          CLOSE
        </button>
      </>
    );
  } else {
    body = (
      <>
        <p className="u-marg-bottom u-color-neg">
          Something went wrong clearing the Payments Table.
        </p>
        <button
          className="c-button +neg u-pad-left u-marg"
          onClick={onClose}
        >
          CLOSE
        </button>
      </>
    );
  }

  return (
    <div style={overlayStyle} onClick={handleOverlayClick}>
      <div style={dialogStyle} onClick={(e) => e.stopPropagation()}>
        <h3 className="c-heading +h3 u-marg-bottom">Clear Payments Table</h3>
        {body}
      </div>
    </div>
  );
};

export default ClearPaymentsModal;
